import AuthService from "../AuthService";

export default function user({ next, router }) {
  if (AuthService.user["is_admin"]) {
    return router.replace({
      name: "StudentList",
    });
  }
  return next();
}
